import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'replaceUndefined'})
export class ReplaceUndefinedPipe implements PipeTransform {
  transform(value: string): string {


    return value? value.replace(/null,|undefined|null/g, " ") : value;
  }
}